var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',{staticClass:"price"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.priceText))]),_vm._v(" "),(_vm.discountText)?_c('span',{staticClass:"discount"},[_vm._v(_vm._s(_vm.discountText))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }